import { Mesh, PlaneGeometry, ShadowMaterial } from 'three'

export class Ground {
    constructor(scene, { size = 60, y = -1, opacity = 0.2 } = {}) {
        this.mesh = new Mesh(
            new PlaneGeometry(size, size, 4),
            new ShadowMaterial({ opacity }),
        )
        this.mesh.receiveShadow = true
        this.mesh.rotation.x = -Math.PI * 0.5
        this.mesh.position.y = y
        scene.add(this.mesh)
    }
}
